<div class="layout-dashboard" *ngIf="venueService.subscriptionVenue.value.key">
	<p-card *ngIf="!venueService.ooVenue && loaded">
		<div class="p-grid">
			<div class="p-col" style="text-align: center">
				<h2><span style="color: red">FocusOnline is not enabled for this venue.</span></h2>
			</div>
		</div>
	</p-card>

	<div class="p-grid p-ai-start vertical-container">
		<div class="p-col-12 p-md-4 p-xl-4">
			<div class="card no-gutter widget-overview-box widget-overview-box-1">
				<div class="d-flex">
					<span class="overview-icon">
						<i class="pi pi-shopping-cart"></i>
					</span>
					<span class="overview-title">Orders</span>
				</div>

				<div class="p-grid overview-detail">
					<div class="col-6">
						<div class="overview-number">
							<span *ngIf="loaded">
								{{ orders.inStoreCount }}
							</span>
							<span *ngIf="!loaded">
								<p-skeleton></p-skeleton>
							</span>
						</div>
						<div class="overview-subtext">In-Store</div>
					</div>
					<div class="col-6">
						<div class="overview-number">
							<span *ngIf="loaded">
								{{ orders.onlineCount }}
							</span>
							<span *ngIf="!loaded">
								<p-skeleton></p-skeleton>
							</span>
						</div>
						<div class="overview-subtext">Online</div>
					</div>
				</div>
			</div>
		</div>
		<div class="p-col-12 p-md-4 p-xl-4">
			<div class="card no-gutter widget-overview-box widget-overview-box-2">
				<div class="d-flex">
					<span class="overview-icon">
						<i class="pi pi-dollar"></i>
					</span>
					<span class="overview-title">Revenue</span>
				</div>

				<div class="p-grid overview-detail">
					<div class="col-6">
						<div class="overview-number">
							<span *ngIf="loaded">
								{{ orders.inStoreRevenue | currency: "USD" }}
							</span>
							<span *ngIf="!loaded">
								<p-skeleton></p-skeleton>
							</span>
						</div>
						<div class="overview-subtext">In-Store</div>
					</div>
					<div class="col-6">
						<div class="overview-number">
							<span *ngIf="loaded">
								{{ orders.onlineRevenue | currency: "USD" }}
							</span>
							<span *ngIf="!loaded">
								<p-skeleton></p-skeleton>
							</span>
						</div>
						<div class="overview-subtext">Online</div>
					</div>
				</div>
			</div>
		</div>
		<div class="p-col-12 p-md-4 p-xl-4">
			<div class="card no-gutter widget-overview-box widget-overview-box-4">
				<div class="d-flex">
					<span class="overview-icon">
						<i class="pi pi-comment"></i>
					</span>
					<span class="overview-title">Surveys</span>
				</div>

				<div class="p-grid overview-detail">
					<div class="col-6">
						<div class="overview-number">
							<span *ngIf="loaded">
								<!-- {{ guestSurvey.happy }} -->
							</span>
							<span *ngIf="!loaded">
								<p-skeleton></p-skeleton>
							</span>
						</div>
						<div class="overview-subtext">Happy</div>
					</div>
					<div class="col-6">
						<div class="overview-number">
							<span *ngIf="loaded">
								<!-- {{ guestSurvey.unhappy }} -->
							</span>
							<span *ngIf="!loaded">
								<p-skeleton></p-skeleton>
							</span>
						</div>
						<div class="overview-subtext">Unhappy</div>
					</div>
				</div>
			</div>
		</div>
		<div class="p-col-12 p-md-4 p-xl-4">
			<app-system-status-dashboard></app-system-status-dashboard>
		</div>
		<div class="p-col-12 p-md-4 p-xl-4" *ngIf="kitchenPerformance">
			<app-kitchen-performance-dashboard></app-kitchen-performance-dashboard>
		</div>
	</div>
	<div class="p-grid p-ai-start vertical-container">
		<div class="p-col-12 md:p-col-12 p-xl-6">
			<app-customer-dashboard-widget></app-customer-dashboard-widget>
		</div>
		<div class="p-col-12 md:p-col-12 p-xl-6 h-100">
			<div class="card no-gutter widget-overview-box widget-overview-box-1 h-100">
				<div class="d-flex">
					<span class="overview-icon">
						<fa-icon [icon]="['far', 'chart-line']"></fa-icon>
					</span>
					<span class="overview-title">
						<div class="d-flex">
							<div>Performance</div>
						</div>
					</span>
				</div>
				<app-product-use-dashboard></app-product-use-dashboard>
			</div>
		</div>
	</div>

	<div class="mt-2">
		<app-checks-dashboard></app-checks-dashboard>
	</div>
</div>
